import { ToastProvider } from "@dream/ui";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TooltipProvider } from "@/components/ui/tooltip";
import "@dream/ui/styles.css";
import { ApiError } from "./api/client.ts";
import { PreferencesProvider } from "./preferences/provider.tsx";
import { router } from "./router.tsx";
import { ThemeProvider } from "./theme/theme.tsx";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // O calendário reage a WebSocket; refetch a cada foco de janela seria
      // trabalho redundante. O resync explícito da reconexão cobre o caso real.
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      gcTime: 5 * 60_000,
      retry: (count, error) => {
        // 4xx são definitivos: repetir só gasta rate limit e atrasa o erro na
        // tela. 5xx e falha de rede valem uma segunda tentativa.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return count < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    },
    mutations: { retry: false },
  },
});

const container = document.getElementById("root");
if (container === null) throw new Error("Elemento #root não encontrado no index.html");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <PreferencesProvider>
          <ToastProvider>
            <TooltipProvider delayDuration={220} skipDelayDuration={80}>
              <RouterProvider router={router} context={{ queryClient }} />
            </TooltipProvider>
          </ToastProvider>
        </PreferencesProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
